import { SubscriptionTypeEnum } from '@va/standalone/shared/constants';
import { makeAction } from '@va/store';
import { WixOnboardingStepsEnum } from '@va/wix/shared/constants';
import * as Types from './types';

export const migrationEmailSent = makeAction(Types.MIGRATION_EMAIL_SENT, 'data');

export const savePremiumPlanSucceeded = makeAction(Types.SAVE_PREMIUM_PLAN_SUCCEEDED, 'data');
export const savePremiumPlanFailed = makeAction(Types.SAVE_PREMIUM_PLAN_FAILED, 'error');

export const setInitialUpgradePlanId = makeAction<[string]>(Types.SET_INITIAL_UPGRADE_PLAN_ID, 'data');
export const setInitialUpgradePlanSubscriptionType = makeAction<[SubscriptionTypeEnum]>(
  Types.SET_INITIAL_UPGRADE_PLAN_SUBSCRIPTION_TYPE,
  'data',
);

export const setInitialOnboardingStep = makeAction<[WixOnboardingStepsEnum]>(Types.SET_INITIAL_ONBOARDING_STEP, 'data');
